import http from '@/utils/http';

/**
 * 获取体检次数排行榜
 */
export const getTimeRanking = () => {
    return http({
        url: '/api/area/v2/checkup/timeranking',
        method: 'get'
    });
};










// 巡回指导次数
export const guideTime = (params) => {
    return http({
        url: '/api/visual/v2/index/guide',
        params
    })
}
//   课程开展次数(按学校)
export const schoolNum = (params) => {
    return http({
        url: '/api/visual/v2/index/courseRecord/school',
        params
    })
}
// 资源下载次数
export const schoolFile = (params) => {
    return http({
        url: '/api/visual/v2/index/fileDownload',
        params
    })
}
// 课程类型占比
export const schoolCourse = (params) => {
    return http({
        url: '/api/visual/v2/index/courseType',
        params
    })
}
//  课程开展次数(按学校)
export const courseNUm = (params) => {
    return http({
        url: '/api/visual/v2/index/courseRecord/school',
        params
    })
}

// 视障类型
export const blindNum = (params) => {
    return http({
        url: '/api/visual/v2/index/blind',
        params
    })
}

// export const blindNum = (params) => {
//     return http({
//         url: '/api/visual/v2/index/blindTemp',
//         params
//     })
// }



